import StaticReplacementsProcessor from '../webPlayTitleReplacementsProcessors/StaticReplacementsProcessor.js'
import ActionCardReplacementsProcessor from '../webPlayTitleReplacementsProcessors/ActionCardReplacementsProcessor.js'

const WEB_PLAY_TITLE_DEFAULT_TEMPLATE = '$PlayTerm from $Sender'

export default class WebPlayTitleGenerator {
  constructor(playTerm, senderEmail, actionCardModel) {
    this.playTerm = playTerm
    this.senderEmail = senderEmail
    this.actionCardModel = actionCardModel
  }

  generateTitle(template) {
    let result = template || WEB_PLAY_TITLE_DEFAULT_TEMPLATE
    for (const processor of this.getReplacementsProcessors()) {
      result = processor.process(result)
    }
    return result
  }

  *getReplacementsProcessors() {
    yield new StaticReplacementsProcessor(this.playTerm, this.senderEmail)
    yield new ActionCardReplacementsProcessor(this.actionCardModel)
  }
}
